
import React, {
  lazy, Suspense, useCallback, useEffect, useState, useMemo,
} from 'react';
import { Provider, useDispatch } from 'react-redux';
import {
  BrowserRouter,
} from 'react-router-dom';

import {
  CssBaseline, ThemeProvider, createTheme,
} from '@material-ui/core';
import {
  makeStyles, Theme, createStyles,
} from '@material-ui/core/styles';

import * as api from './api';
import configureStore from '@ivymobi/orbit-core/business/configureStore';

import _ from 'lodash';

import Loader from './components/loaders';
// import Main from './main';
const Main = lazy(
  () => import('./main' /* webpackChunkName: "share" */)
);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      zIndex: 1,
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      minHeight: '100vh',
      // minWidth: 'fit-content',
      width: '100%',
      backgroundColor: theme.palette.background.default,
      color: theme.palette.getContrastText(
        theme.palette.background.default
      ),
    },
  })
);

export default function OrbitApp() {
  const store = configureStore(api, {});

  return (
    <BrowserRouter>
      <Provider store={store}>
        <CssBaseline />
        <Suspense fallback={<Loader />} >
          <Main />
          {/* <Loader /> */}
        </Suspense>
      </Provider>
    </BrowserRouter>
  );
}
